import requests from '../requests'
import { ReviewData } from '../types'
import actions from './actions'

export const operationFetchUnreviewedProductsData =
  (userId: string, endpoint: string) => async (dispatch) => {
    dispatch(actions.fetchUnreviwedProductsStart())

    try {
      const unreviewedProductsData = await requests.fetchUnreviewedProducts(userId, endpoint)
      if (unreviewedProductsData) {
        dispatch(actions.fetchUnreviwedProductsSuccess(unreviewedProductsData))
      } else {
        dispatch(actions.fetchUnreviwedProductsFail())
      }
    } catch (error) {
      dispatch(actions.fetchUnreviwedProductsFail())
    }
  }

export const operationCreateReview = (data: ReviewData, endpoint: string) => async (dispatch) => {
  dispatch(actions.createReviewStart())

  try {
    const result = await requests.createReview(data, endpoint)
    dispatch(actions.createReviewSuccess(result))
  } catch (error) {
    dispatch(actions.createReviewFail())
  }
}
